export interface EventData {
  id: number;
  slug: string;
  name: string;
  date: string;
  location: string;
  description: string;
  iconType: 'running' | 'football';
  longDescription: string;
  schedule: { time: string; activity: string }[];
  details: { label: string; value: string }[];
}

export const events: EventData[] = [
  {
    id: 1,
    slug: 'holmenkollstaffeten-26',
    name: 'Holmenkollstaffeten 26',
    date: 'TBA 2026',
    location: 'Holmenkollen, Oslo',
    description:
      'Bli med på et episk arrangement under Holmenkollstafetten! Liveopptreden og drittmusikk garantert.',
    iconType: 'running',
    longDescription:
      'Holmenkollstafetten er en av Oslos mest ikoniske stafetter, og Smuglergods er der for å skape stemning. Forvent liveopptredener, eksklusiv merch og en hel dag med drittmusikk i bakkene rundt Holmenkollen. Enten du løper eller heier, blir dette en opplevelse du sent glemmer.',
    schedule: [
      { time: 'TBA', activity: 'Portene åpner og oppvarming' },
      { time: 'TBA', activity: 'Løpsstart' },
      { time: 'TBA', activity: 'Smuglergods live-set' },
      { time: 'TBA', activity: 'Premieutdeling og etterfest' },
    ],
    details: [
      { label: 'Type', value: 'Stafett og liveopptreden' },
      { label: 'Kapasitet', value: 'Utendørs — ubegrenset publikum' },
      { label: 'Pris', value: 'Gratis for publikum' },
      { label: 'Alder', value: 'Alle aldre' },
    ],
  },
  {
    id: 2,
    slug: 'lokkecup-26',
    name: 'Løkkecup 26',
    date: 'TBA 2026',
    location: 'Løkka, Oslo',
    description:
      'Den legendariske Løkkecupen er tilbake! Forvent tøff konkurranse og enda bedre musikk.',
    iconType: 'football',
    longDescription:
      'Løkkecup er gatefotballturneringen som har blitt en kulturinstitusjon på Grünerløkka. Smuglergods er stolte av å være en del av årets utgave med beats mellom kampene og feststemning rundt banen. Lag fra hele Oslo konkurrerer mens nabolaget samles for en dag med fotball, mat og musikk.',
    schedule: [
      { time: 'TBA', activity: 'Registrering og innsjekk av lag' },
      { time: 'TBA', activity: 'Gruppespill' },
      { time: 'TBA', activity: 'Pause-show med Smuglergods' },
      { time: 'TBA', activity: 'Finaler og feiring' },
    ],
    details: [
      { label: 'Type', value: 'Gatefotballturnering og livemusikk' },
      { label: 'Kapasitet', value: 'Utendørs — åpent for alle' },
      { label: 'Pris', value: 'Gratis inngang' },
      { label: 'Alder', value: 'Alle aldre' },
    ],
  },
];

export function getEventBySlug(slug: string): EventData | undefined {
  return events.find((event) => event.slug === slug);
}
